<template>
  <v-dialog
    width="700"
    v-model="showDialog"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="mr-4 mb-4 btn-wrap"
        plain
        text
        x-large
        v-on="on"
        color="primary"
      >
        <v-icon class="patient-overview__icon">mdi-printer</v-icon>
        {{ $ucfirst($t('printQRCodeMobile')) }}
      </v-btn>
    </template>

    <vue-qrcode
        v-if="password"
        class="session-qr-min__code hidden"
        id="qr-code-mobile-app"
        :value="password"
        style="display: none"
    />

    <v-card>
      <div class="clearfix">
        <v-btn
          class="pull-right btn-transparent"
          icon
          plain
          @click="showDialog = false"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div class="pa-5">
        <div class="d-flex justify-center align-center pb-5 px-3 patient-overview-parameter--red">
          <v-icon
            :color="$color.coro['warning-500']"
            class="mr-4"
          >
            mdi-alert
          </v-icon>
          {{ $ucfirst($t('printQRResetPassword')) }}
        </div>
        <div class="d-flex justify-space-around pb-5">
          <v-btn
            color="primary"
            outlined
            :x-large="$vuetify.breakpoint.mdAndUp"
            @click="printQRCodeMobileApp"
          >
            {{ $ucfirst($t('confirm')) }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            :x-large="$vuetify.breakpoint.mdAndUp"
            @click="showDialog = false"
          >
            {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
          </v-btn>
        </div>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
import VueQrcode from 'vue-qrcode'

/**
 * Component ResetPasswordButton.vue
 *
 * @module ResetPasswordButton
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/APP_DASHBOARD/templates/components/Parts/ResetPasswordButton.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'ResetPasswordButton',
  components: {
    VueQrcode
  },
  props: {
    patientId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDialog: false,
      password: ''
    }
  },
  methods: {
    async printQRCodeMobileApp() {
      const passwordData = await this.$store.dispatch('patientSummary/resetPassword', this.patientId);
      const newPassword = passwordData?.setPasswordForPatient;

      if (newPassword) {
        this.password = newPassword;

        setTimeout(() => {
          const { src } = document.getElementById('qr-code-mobile-app');
          const iframe = `<iframe width="100%" height="100%" src="${src}"></iframe>`;
          const isFirefox = navigator.userAgent
              .toLowerCase().indexOf('firefox') > -1;

          if (!src) return;

          const payload = isFirefox ? src : '';
          const popup = window.open(payload);

          const closePopup = () => {
            if (popup) {
              popup.close();
            }
          }

          popup.onbeforeunload = closePopup;
          popup.onafterprint = closePopup;

          setTimeout(() => {
            if (!isFirefox) {
              popup.document.write(iframe);
            } else {
              alert()
            }

            popup.focus();
            popup.print();
            this.password = '';
          }, 100);
        }, 100);
      }

      this.showDialog = false;
    },
  },
};
</script>
